export const CHECKOUT_URL =
  'https://girlsflagfootballcoachsystem.impultienda.ar/checkout'

export const IMAGES = {
  bundle:
    'https://cdn.magicpatterns.com/uploads/m215fG2UseHfFpHDVxWX4H/ChatGPT_Image_9_sept_2026,_00_11_01.png',
}

export type SamplePage = {
  src: string
  category: string
  title: string
  alt: string
}

export const samplePages: SamplePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ibeHq6EZ9CjpKvRa2nE4hL/Girls_Flag_Vol3_Page_14.jpg',
    category: 'Offense playbook',
    title: 'OD-08 — Flat Route (Outside Break)',
    alt: 'Playbook page OD-08 Flat Route, with a field diagram of three receivers breaking outside, route details, QB reads, when to use, coaching cues and common mistakes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oxYDZprR1ie39PoH3yHfAP/Girls_Flag_Vol3_Page_16.jpg',
    category: 'Offense playbook',
    title: 'OD-10 — Flood Route (Three to One Side)',
    alt: 'Playbook page OD-10 Flood Route, showing deep, mid and short receivers flooding one side with the QB read progression.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wWS9qAYGQ7YVZVFqrJ4Sve/Girls_Flag_Vol3_Page_20.jpg',
    category: 'Offense playbook',
    title: 'OD-14 — Y-Cross Route',
    alt: 'Playbook page OD-14 Y-Cross Route, a field diagram of vertical and crossing layers with why it works, when to use and a coaching cue.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7DSnh1NLF6rs4BEC4akwfv/Girls_Flag_Vol3_Page_26.jpg',
    category: 'Offense playbook',
    title: 'OD-20 — Reverse (Trick Play)',
    alt: 'Playbook page OD-20 Reverse trick play, showing the defense flowing right while R2 attacks left, with how it works and common mistakes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/epHUq79YtmQmFyKTNu8GsM/Girls_Flag_Vol3_Page_35.jpg',
    category: 'Defense playbook',
    title: 'OD-31 — Slant Route Defense',
    alt: 'Defense page OD-31 Slant Route Defense, with defenders reacting to inside breaks toward flag pull targets and a four-step reaction key.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hYEK11KJjxpWeR5eTrFuzg/Girls_Flag_Vol3_Page_43.jpg',
    category: 'Defense playbook',
    title: 'OD-39 — Screen Defense',
    alt: 'Defense page OD-39 Screen Defense, showing defenders swarming the ball carrier on a short pass with five recognition and reaction steps.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/v5uHeDGPgKt4BRAvu4fcJu/Girls_Flag_Vol2_Page_50.jpg',
    category: 'Skill drill',
    title: 'SD-042 — Zone / Gap Responsibility',
    alt: 'Skill drill page SD-042 Zone and Gap Responsibility, with goal, cues, a four-zone cone diagram, setup, run-it steps and easier and harder variations.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vwwmtCXtCXrMTthwc6tZtC/Girls_Flag_Vol2_Page_55.jpg',
    category: 'Skill drill',
    title: 'SD-046 — Change of Direction: Plant & Cut',
    alt: 'Skill drill page SD-046 Change of Direction Plant and Cut, with a three-cone diagram, setup, run-it steps and easier and harder variations.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gCWPacwXK3Gk7iQSXfwRHr/Girls_Flag_Vol2_Page_59.jpg',
    category: 'Skill drill',
    title: 'SD-050 — Speed & Agility Team Challenge',
    alt: 'Skill drill page SD-050 Speed and Agility Team Challenge, a five-station circuit diagram with setup, run-it steps and easier and harder variations.',
  },
]

export type Stage = {
  label: string
  description: string
}

export const stages: Stage[] = [
  {
    label: 'Open',
    description:
      'Open the system and go straight to the volume you need for today.',
  },
  {
    label: 'Choose',
    description:
      'Choose a written drill, a play concept or a complete ready-to-run practice.',
  },
  {
    label: 'Coach',
    description:
      'Run the session with a clear plan, then repeat it next practice without starting over.',
  },
]

export type Volume = {
  number: number
  stage: string
  title: string
  benefit: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    stage: 'Foundations',
    title: 'Girls Flag Foundations™',
    benefit:
      'Understand the game, build the team, establish standards and create a strong Girls Flag Football environment.',
  },
  {
    number: 2,
    stage: 'Skill development',
    title: 'Skill Development System™',
    benefit:
      '50 written skill drills and progressions covering the essential technical skills of Girls Flag Football.',
  },
  {
    number: 3,
    stage: 'Strategy',
    title: 'Offense & Defense Playbook™',
    benefit:
      'Offensive and defensive concepts, formations, reads and tactical systems you can understand and apply with your team.',
  },
  {
    number: 4,
    stage: 'Practice planning',
    title: 'Practice Builder System™',
    benefit:
      'A structured methodology for building organized, purposeful practices without improvising every session.',
  },
  {
    number: 5,
    stage: 'Season & game day',
    title: 'Season & Game-Day System™',
    benefit:
      'Organize the season, prepare for competition and make smarter game-day coaching decisions.',
  },
  {
    number: 6,
    stage: 'Ready to run',
    title: 'Ready-To-Run Practice Library™',
    benefit:
      '36 complete written practices so you can open the system, choose a session and coach.',
  },
]

export type Bonus = {
  number: number
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The Confident Coach Scriptbook™',
    description:
      'Written language for teaching, correcting and leading players with calm authority.',
  },
  {
    number: 2,
    title: 'Parent Communication Copy Vault™',
    description:
      'Ready-to-use written messages for updates, expectations and season communication.',
  },
  {
    number: 3,
    title: 'First-Time Girls Flag Coach Survival Guide™',
    description:
      'A practical starting point for your first season, from first practice to final game.',
  },
  {
    number: 4,
    title: 'Girls Flag Football Plain-English Glossary™',
    description:
      'Every term, position and concept explained in plain language you can teach from.',
  },
  {
    number: 5,
    title: 'Team Culture Codebook™',
    description:
      'Standards, routines and habits that build a team players want to show up for.',
  },
]

export const builtToHelp: string[] = [
  'Spend less time planning practices from a blank page',
  'Keep drills, plays and practices organized in one system',
  'Move from skill work to game strategy with a clearer structure',
  'Run more consistent, purposeful sessions all season',
]

export const offerIncludes: string[] = [
  '6 Professional Coaching Volumes',
  '5 Practical Bonus Resources',
  '50 Written Skill Drills',
  '36 Ready-To-Run Practices',
  'OPEN → CHOOSE → COACH framework',
  'Instant Digital Access',
  'One-Time Payment',
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is Girls Flag Football Coach System™ a physical product?',
    answer:
      'No. Girls Flag Football Coach System™ is a 100% digital, written coaching system. Nothing is shipped physically.',
  },
  {
    question: 'Is this a course?',
    answer:
      'No. This is not a course or training program. It is one complete written coaching system built for reference and day-to-day practice organization.',
  },
  {
    question: 'Is this software or an app?',
    answer:
      'No. There is nothing to install and no subscription. Everything is delivered digitally as written material you open and use.',
  },
  {
    question: 'Is it suitable for first-time Girls Flag Football coaches?',
    answer:
      'Yes. The structure is especially useful when you want a clear starting point for building the team, teaching skills and planning organized practices.',
  },
  {
    question: 'Can experienced coaches use it?',
    answer:
      'Yes. It is also built for experienced coaches who want to stop hunting for random drills and keep their skill work, plays and practices in one organized system.',
  },
  {
    question: 'Does it work for different age groups?',
    answer:
      'Yes. The drills, progressions and practice structures are written so you can adjust the demand and complexity to the age and experience level you coach.',
  },
  {
    question: 'Does it work for both 5v5 and 7v7 formats?',
    answer:
      'Yes. The skill work, concepts and practice structures apply across common formats. Formats, rushing, eligibility, contact and QB running rules vary between leagues, so always follow your specific league or organization rules.',
  },
  {
    question: 'Are the 50 drills videos?',
    answer:
      'No. All 50 drills are written drills and progressions, with the setup, coaching points and progression explained in text. There are no videos.',
  },
  {
    question: 'Are the 36 practices already written and ready to use?',
    answer:
      'Yes. All 36 practices are complete and already written. You open the system, choose a session and coach it.',
  },
  {
    question: 'Does this replace a coach’s judgment or league rules?',
    answer:
      'No. Girls Flag Football Coach System™ is a coaching reference and organization system. It does not replace your judgment, player safety decisions, or the rules of your specific league or organization, which always take priority.',
  },
  {
    question: 'How do I receive it?',
    answer: 'You receive instant digital access after completing your purchase.',
  },
]
